import React, { PureComponent, ReactNode } from 'react';
import { IntlShape } from 'react-intl';
import { Col, Container, Row } from 'reactstrap';
import ActivityMonitor from '../../utils/helpers/ActivityMonitor';
import Header from '../common/header/Header';
import Seo from '../common/header/Seo';
import SideNavBar from '../common/sidebar/SideNavBar';
import './Layout.scss';
import Footer from '../common/footer/Footer';

const showResponsiveSideNav = false;

/**
 * @interface LayoutProps
 * @description Contains Layout component props attributes and types
 */

interface LayoutProps {
  /**
   * @field children
   * @description Any react component to be render with layout
   * @type {React.ReactNode}
   * @memberof LayoutProps
   */
  children: React.ReactNode;
  /**
   * @field intl
   * @description Internationalization object
   * @type {IntlShape}
   * @memberof LayoutProps
   */
  intl: IntlShape;

  /**
   * @field activeSubmissionId
   * @description Active Submisstion ID
   * @type {String}
   * @memberof LayoutProps
   */
  activeSubmissionId?: string;
}

/**
 * @interface LayoutState
 * @description Contains Layout component state attributes and types
 */
interface LayoutState {
  /**
   * @field showResponsiveSideNav
   * @description To show the mobile responsive Side Nav
   * @type {boolean}
   * @memberof LayoutState
   */
  showResponsiveSideNavState: boolean;
}

/**
 * @component Layout
 * @description Skeleton component to render each page with layout
 */
class Layout extends PureComponent<LayoutProps, LayoutState> {
  constructor(props: LayoutProps) {
    super(props);
    this.state = {
      showResponsiveSideNavState: false,
    };
  }

  componentDidMount(): void {
    if (showResponsiveSideNav) {
      this.setState({
        showResponsiveSideNavState: showResponsiveSideNav,
      });
    }
  }

  private toggleResponsiveSideNav = (): void => {
    // Will implement in future
    const { showResponsiveSideNavState } = this.state;
    this.setState({
      showResponsiveSideNavState: !showResponsiveSideNavState,
    });
  };

  render(): ReactNode {
    const { showResponsiveSideNavState } = this.state;
    const { children, intl } = this.props;
    return (
      <Container fluid className='layout mh-100'>
        <Seo />
        <Header
          toggleResponsiveSideNav={this.toggleResponsiveSideNav}
          intl={intl}
          showResponsiveSideNav={showResponsiveSideNavState}
        />
        <Row className='mh-100 content-container'>
          {showResponsiveSideNavState && (
            <Col className='sidebar'>
              <nav aria-label='sidebar' className='side-nav'>
                <SideNavBar toggleResponsiveSideNavProps={this.toggleResponsiveSideNav} />
              </nav>
            </Col>
          )}
          <Col className={showResponsiveSideNavState ? 'main-content pt-2 pl-2 col-10' : 'main-content pt-2 pl-2'}>
            <Container fluid>
              <main role='main' className='main'>
                {children}
              </main>
              <ActivityMonitor timeout={1200} listenForEvents={['click', 'touch', 'mousemove', 'keyup']} />
            </Container>
          </Col>
          <div className='footer-container'>
            <Footer />
          </div>
        </Row>
      </Container>
    );
  }
}

export default Layout;
